import './kitStyles';
import React from 'react';

/**
 * WEB-3310 юнит 1 — сегменты кита, эталон `Seg({ value, onChange, options, size,
 * label, testid })`: `div.seg [sm][role=group]`, кнопки с `aria-pressed`,
 * `title`, `disabled`. Клавиатура эталона — Tab по кнопкам, Enter и Пробел
 * выбирают; стрелок нет.
 */
export interface SegOption<V extends string = string> {
  value: V;
  label: React.ReactNode;
  title?: string;
  disabled?: boolean;
}

export interface SegProps<V extends string = string> {
  value: V;
  onChange: (value: V) => void;
  options: ReadonlyArray<SegOption<V>>;
  size?: 'sm';
  label?: string;
  testid?: string;
}

export function Seg<V extends string = string>({
  value,
  onChange,
  options,
  size,
  label,
  testid,
}: SegProps<V>): React.ReactElement {
  return (
    <div className={'seg ' + (size || '')} role="group" aria-label={label} data-testid={testid}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={o.value === value}
          title={o.title}
          disabled={o.disabled}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
